/*
 * Copyright (c) 2026 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import useThemeContext from '../theme/useThemeContext';
import {IconProps} from '../types/types';
/* ============================================================================
 * DLS ICON IMPORTS
 * ============================================================================
 *
 * NOTE:
 * - All new-theme icons are statically imported.
 * - Each module is evaluated once and shared across the app.
 */
import AssetAirplaneIcon from './current/AssetAirplaneIcon';
import AssetAirplaneOutlinedIcon from './current/AssetAirplaneOutlinedIcon';
import AssetCargoIcon from './current/AssetCargoIcon';
import AssetDeviceIcon from './current/AssetDeviceIcon';
import AssetDriverOutlinedIcon from './current/AssetDriverOutlinedIcon';
import AssetEquipmentIcon from './current/AssetEquipmentIcon';
import AssetRouteOutlinedIcon from './current/AssetRouteOutlinedIcon';
import AssetShipIcon from './current/AssetShipIcon';
import AssetShipmentOutlined from './current/AssetShipmentOutlined';
import AssetShipOutlinedIcon from './current/AssetShipOutlinedIcon';
import AssetToolIcon from './current/AssetToolIcon';
import AssetToolOutlinedIcon from './current/AssetToolOutlinedIcon';
import AssetTrailerIcon from './current/AssetTrailerIcon';
import AssetTrailerOutlinedIcon from './current/AssetTrailerOutlinedIcon';
import AssetTrainIcon from './current/AssetTrainIcon';
import AssetTrainOutlineIcon from './current/AssetTrainOutlineIcon';
import AssetVehicleIcon from './current/AssetVehicleIcon';
import AssetVehicleOutlinedIcon from './current/AssetVehicleOutlinedIcon';
import BatteryIcon from './current/BatteryIcon';
import BatteryLowIcon from './current/BatteryLowIcon';
import ChargeLevelIcon from './current/ChargeLevelIcon';
import ColumnChooserIcon from './current/ColumnChooserIcon';
import CreateGeoFenceIcon from './current/CreateGeoFenceIcon';
import DashboardShare from './current/DashboardShare';
import DefaultAvatarIcon from './current/DefaultAvatarIcon';
import DropdownArrowIcon from './current/DropdownArrowIcon';
import EventHistoryBadgeIcon from './current/EventHistoryBadgeIcon';
import EventHistoryLocationIcon from './current/EventHistoryLocationIcon';
import EventSafetyIcon from './current/EventSafetyIcon';
import EventSpeedIcon from './current/EventSpeedIcon';
import FilterIcon from './current/FilterIcon';
import FolderShared from './current/FolderShared';
import FolderSharedOpened from './current/FolderSharedOpened';
import FuelPumpIcon from './current/FuelPumpIcon';
import GeofencesDrawIcon from './current/GeofencesDrawIcon';
import GeofencesPolygonIcon from './current/GeofencesPolygonIcon';
import GeofencesRadialIcon from './current/GeofencesRadialIcon';
import GroupChooserIcon from './current/GroupChooserIcon';
import HomeDefaultView from './current/HomeDefaultView';
import ImportIcon from './current/ImportIcon';
import InfoIcon from './current/InfoIcon';
import LightBulbIcon from './current/LightBulbIcon';
import LightIcon from './current/LightIcon';
import LiveHistoryIcon from './current/LiveHistoryIcon';
import MapBatteryLowIcon from './current/MapBatteryLowIcon';
import MapEditIcon from './current/MapEditIcon';
import MapHarshEventIcon from './current/MapHarshEventIcon';
import MapInputEventIcon from './current/MapInputEventIcon';
import MapLayerIcon from './current/MapLayerIcon';
import MapLocateIcon from './current/MapLocateIcon';
import MapPinIcon from './current/MapPinIcon';
import MapViewIcon from './current/MapViewIcon';
import MapZoomInIcon from './current/MapZoomInIcon';
import MapZoomOutIcon from './current/MapZoomOutIcon';
import MaterialAddIcon from './current/MaterialAddIcon';
import MaterialBackIcon from './current/MaterialBackIcon';
import MaterialBatteryIcon from './current/MaterialBatteryIcon';
import MaterialChargeStationIcon from './current/MaterialChargeStationIcon';
import MaterialCheckIcon from './current/MaterialCheckIcon';
import MaterialCloudUploadIcon from './current/MaterialCloudUploadIcon';
import MaterialDeleteIcon from './current/MaterialDeleteIcon';
import MaterialDragIcon from './current/MaterialDragIcon';
import MaterialDropdownExpandIcon from './current/MaterialDropdownExpandIcon';
import MaterialDropdownIcon from './current/MaterialDropdownIcon';
import MaterialExceptionIcon from './current/MaterialExceptionIcon';
import MaterialExitCloseIcon from './current/MaterialExitCloseIcon';
import MaterialExpandLessIcon from './current/MaterialExpandLessIcon';
import MaterialExpandMoreIcon from './current/MaterialExpandMoreIcon';
import MaterialEyeOffIcon from './current/MaterialEyeOffIcon';
import MaterialEyeOnIcon from './current/MaterialEyeOnIcon';
import MaterialFilledBackIcon from './current/MaterialFilledBackIcon';
import MaterialFilledStarIcon from './current/MaterialFilledStarIcon';
import MaterialFilledUpIcon from './current/MaterialFilledUpIcon';
import MaterialForwardIcon from './current/MaterialForwardIcon';
import MaterialFullScreenExitIcon from './current/MaterialFullScreenExitIcon';
import MaterialFullScreenIcon from './current/MaterialFullScreenIcon';
import MaterialIgnitionIcon from './current/MaterialIgnitionIcon';
import MaterialMoreVertIcon from './current/MaterialMoreVertIcon';
import MaterialMovingIcon from './current/MaterialMovingIcon';
import MaterialOfflineIcon from './current/MaterialOfflineIcon';
import MaterialPhotoIcon from './current/MaterialPhotoIcon';
import MaterialPlayIcon from './current/MaterialPlayIcon';
import MaterialRefreshIcon from './current/MaterialRefreshIcon';
import MaterialRotateIcon from './current/MaterialRotateIcon';
import MaterialSaveFilterIcon from './current/MaterialSaveFilterIcon';
import MaterialStopIcon from './current/MaterialStopIcon';
import MaterialVolumeIcon from './current/MaterialVolumeIcon';
import NoIgnitionIcon from './current/NoIgnitionIcon';
import NotificationCalendarIcon from './current/NotificationCalendarIcon';
import NotificationConnectivityIcon from './current/NotificationConnectivityIcon';
import NotificationGeneralAlertIcon from './current/NotificationGeneralAlertIcon';
import NotificationVerifiedFilledIcon from './current/NotificationVerifiedFilledIcon';
import NotificationVerifiedIcon from './current/NotificationVerifiedIcon';
import PowerOnOffIcon from './current/PowerOnOffIcon';
import ProgressDownIcon from './current/ProgressDownIcon';
import ProgressUpIcon from './current/ProgressUpIcon';
import RepeatIcon from './current/RepeatIcon';
import ReportsIcon from './current/ReportsIcon';
import RouteIcon from './current/RouteIcon';
import SavedMapViewsIcon from './current/SavedMapViewsIcon';
import SaveIcon from './current/SaveIcon';
import ShockIcon from './current/ShockIcon';
import SideNavAdminIcon from './current/SideNavAdminIcon';
import SideNavCollapseBarIcon from './current/SideNavCollapseBarIcon';
import SideNavCrashboxxIcon from './current/SideNavCrashboxxIcon';
import SideNavDashboardIcon from './current/SideNavDashboardIcon';
import SideNavEventsIcon from './current/SideNavEventsIcon';
import SideNavExpandBarIcon from './current/SideNavExpandBarIcon';
import SideNavInspectionsIcon from './current/SideNavInspectionsIcon';
import SideNavIssuesIcon from './current/SideNavIssuesIcon';
import SideNavMaintenanceIcon from './current/SideNavMaintenanceIcon';
import SideNavReportsIcon from './current/SideNavReportsIcon';
import SideNavTrackingIcon from './current/SideNavTrackingIcon';
import SideNavVisionIcon from './current/SideNavVisionIcon';
import StarsFillIcon from './current/StarsFillIcon';
import StarsIcon from './current/StarsIcon';
import StatusIcon from './current/StatusIcon';
import StopIcon from './current/StopIcon';
import SystemAddIcon from './current/SystemAddIcon';
import SystemAssociationIcon from './current/SystemAssociationIcon';
import SystemBookmarkIcon from './current/SystemBookmarkIcon';
import SystemCallIcon from './current/SystemCallIcon';
import SystemCallOutlineIcon from './current/SystemCallOutlineIcon';
import SystemContactIcon from './current/SystemContactIcon';
import SystemCustomBoundaryIcon from './current/SystemCustomBoundaryIcon';
import SystemDateTimeIcon from './current/SystemDateTimeIcon';
import SystemDeleteIcon from './current/SystemDeleteIcon';
import SystemDownIcon from './current/SystemDownIcon';
import SystemDownloadFileIcon from './current/SystemDownloadFileIcon';
import SystemDriverFilledIcon from './current/SystemDriverFilledIcon';
import SystemEmailIcon from './current/SystemEmailIcon';
import SystemErrorIcon from './current/SystemErrorIcon';
import SystemEyeOutlineIcon from './current/SystemEyeOutlineIcon';
import SystemEyeSlashOutlineIcon from './current/SystemEyeSlashOutlineIcon';
import SystemFavouriteDefaultIcon from './current/SystemFavouriteDefaultIcon';
import SystemFavouriteFilledIcon from './current/SystemFavouriteFilledIcon';
import SystemFindNearestIcon from './current/SystemFindNearestIcon';
import SystemFolderClosedIcon from './current/SystemFolderClosedIcon';
import SystemFolderOpenedIcon from './current/SystemFolderOpenedIcon';
import SystemGeofenceFilledIcon from './current/SystemGeofenceFilledIcon';
import SystemGeofenceIcon from './current/SystemGeofenceIcon';
import SystemGridIcon from './current/SystemGridIcon';
import SystemInRangeIcon from './current/SystemInRangeIcon';
import SystemMapIcon from './current/SystemMapIcon';
import SystemMoveIcon from './current/SystemMoveIcon';
import SystemNestedIcon from './current/SystemNestedIcon';
import SystemNewMessageIcon from './current/SystemNewMessageIcon';
import SystemNotLinkedIcon from './current/SystemNotLinkedIcon';
import SystemOutOfRangeIcon from './current/SystemOutOfRangeIcon';
import SystemPinIcon from './current/SystemPinIcon';
import SystemPrintIcon from './current/SystemPrintIcon';
import SystemProTipIcon from './current/SystemProTipIcon';
import SystemResizeIcon from './current/SystemResizeIcon';
import SystemSaveExportIcon from './current/SystemSaveExportIcon';
import SystemScanIcon from './current/SystemScanIcon';
import SystemSendIcon from './current/SystemSendIcon';
import SystemSendKudosIcon from './current/SystemSendKudosIcon';
import SystemShareIcon from './current/SystemShareIcon';
import SystemShareOutlineIcon from './current/SystemShareOutlineIcon';
import SystemSignalIcon from './current/SystemSignalIcon';
import SystemSortIcon from './current/SystemSortIcon';
import SystemStreetViewIcon from './current/SystemStreetViewIcon';
import SystemTrackIcon from './current/SystemTrackIcon';
import SystemUploadIcon from './current/SystemUploadIcon';
import SystemVehiclesIcon from './current/SystemVehiclesIcon';
import SystemViewCardsIcon from './current/SystemViewCardsIcon';
import SystemViewHistoryIcon from './current/SystemViewHistoryIcon';
import SystemViewListIcon from './current/SystemViewListIcon';
import TemperatureIcon from './current/TemperatureIcon';
import TireIcon from './current/TireIcon';
import TopNavFilterIcon from './current/TopNavFilterIcon';
import TopNavHelpIcon from './current/TopNavHelpIcon';
import TopNavNotificationIcon from './current/TopNavNotificationIcon';
import TopNavSearchIcon from './current/TopNavSearchIcon';
import TrailerDoorStatusIcon from './current/TrailerDoorStatusIcon';
import TripListIcon from './current/TripListIcon';
import UpArrowIcon from './current/UpArrowIcon';
import UrgentIcon from './current/UrgentIcon';
import VehicleIcon from './current/VehicleIcon';
import VicinitySearchIcon from './current/VicinitySearchIcon';
import VisionCameraOutlinedIcon from './current/VisionCameraOutlinedIcon';
import ZoomToFitIcon from './current/ZoomToFitIcon';

const ICON_MAP = {
  AssetAirplaneIcon,
  AssetAirplaneOutlinedIcon,
  AssetCargoIcon,
  AssetDeviceIcon,
  AssetDriverOutlinedIcon,
  AssetEquipmentIcon,
  AssetRouteOutlinedIcon,
  AssetShipIcon,
  AssetShipOutlinedIcon,
  AssetShipmentOutlined,
  AssetToolIcon,
  AssetToolOutlinedIcon,
  AssetTrailerIcon,
  AssetTrailerOutlinedIcon,
  AssetTrainIcon,
  AssetTrainOutlineIcon,
  AssetVehicleIcon,
  AssetVehicleOutlinedIcon,
  BatteryIcon,
  BatteryLowIcon,
  MapBatteryLowIcon,
  ChargeLevelIcon,
  ColumnChooserIcon,
  CreateGeoFenceIcon,
  DashboardShare,
  DefaultAvatarIcon,
  DropdownArrowIcon,
  EventHistoryBadgeIcon,
  EventHistoryLocationIcon,
  EventSafetyIcon,
  EventSpeedIcon,
  FilterIcon,
  FolderShared,
  FolderSharedOpened,
  FuelPumpIcon,
  GeofencesDrawIcon,
  GeofencesPolygonIcon,
  GeofencesRadialIcon,
  GroupChooserIcon,
  MapHarshEventIcon,
  HomeDefaultView,
  ImportIcon,
  InfoIcon,
  MapInputEventIcon,
  LightBulbIcon,
  LightIcon,
  LiveHistoryIcon,
  MapEditIcon,
  MapLayerIcon,
  MapLocateIcon,
  MapPinIcon,
  MapViewIcon,
  MapZoomInIcon,
  MapZoomOutIcon,
  MaterialAddIcon,
  MaterialBackIcon,
  MaterialBatteryIcon,
  MaterialChargeStationIcon,
  MaterialCheckIcon,
  MaterialCloudUploadIcon,
  MaterialDeleteIcon,
  MaterialDragIcon,
  MaterialDropdownExpandIcon,
  MaterialDropdownIcon,
  MaterialExceptionIcon,
  MaterialExitCloseIcon,
  MaterialExpandLessIcon,
  MaterialExpandMoreIcon,
  MaterialEyeOffIcon,
  MaterialEyeOnIcon,
  MaterialFilledBackIcon,
  MaterialFilledStarIcon,
  MaterialFilledUpIcon,
  MaterialForwardIcon,
  MaterialFullScreenExitIcon,
  MaterialFullScreenIcon,
  MaterialIgnitionIcon,
  MaterialMoreVertIcon,
  MaterialMovingIcon,
  MaterialOfflineIcon,
  MaterialPhotoIcon,
  MaterialPlayIcon,
  MaterialRefreshIcon,
  MaterialRotateIcon,
  MaterialSaveFilterIcon,
  MaterialStopIcon,
  MaterialVolumeIcon,
  NoIgnitionIcon,
  NotificationCalendarIcon,
  NotificationConnectivityIcon,
  NotificationGeneralAlertIcon,
  NotificationVerifiedFilledIcon,
  NotificationVerifiedIcon,
  PowerOnOffIcon,
  ProgressDownIcon,
  ProgressUpIcon,
  RepeatIcon,
  ReportsIcon,
  RouteIcon,
  SaveIcon,
  SavedMapViewsIcon,
  ShockIcon,
  SideNavAdminIcon,
  SideNavCollapseBarIcon,
  SideNavCrashboxxIcon,
  SideNavDashboardIcon,
  SideNavEventsIcon,
  SideNavExpandBarIcon,
  SideNavInspectionsIcon,
  SideNavIssuesIcon,
  SideNavMaintenanceIcon,
  SideNavReportsIcon,
  SideNavTrackingIcon,
  SideNavVisionIcon,
  StarsFillIcon,
  StarsIcon,
  StatusIcon,
  StopIcon,
  SystemAddIcon,
  SystemAssociationIcon,
  SystemBookmarkIcon,
  SystemCallIcon,
  SystemCallOutlineIcon,
  SystemContactIcon,
  SystemCustomBoundaryIcon,
  SystemDateTimeIcon,
  SystemDeleteIcon,
  SystemDownIcon,
  SystemDownloadFileIcon,
  SystemDriverFilledIcon,
  SystemEmailIcon,
  SystemErrorIcon,
  SystemEyeOutlineIcon,
  SystemEyeSlashOutlineIcon,
  SystemFavouriteDefaultIcon,
  SystemFavouriteFilledIcon,
  SystemFindNearestIcon,
  SystemFolderClosedIcon,
  SystemFolderOpenedIcon,
  SystemGeofenceFilledIcon,
  SystemGeofenceIcon,
  SystemGridIcon,
  SystemInRangeIcon,
  SystemMapIcon,
  SystemMoveIcon,
  SystemNestedIcon,
  SystemNewMessageIcon,
  SystemNotLinkedIcon,
  SystemOutOfRangeIcon,
  SystemPinIcon,
  SystemPrintIcon,
  SystemProTipIcon,
  SystemResizeIcon,
  SystemSaveExportIcon,
  SystemScanIcon,
  SystemSendIcon,
  SystemSendKudosIcon,
  SystemShareIcon,
  SystemShareOutlineIcon,
  SystemSignalIcon,
  SystemSortIcon,
  SystemStreetViewIcon,
  SystemTrackIcon,
  SystemUploadIcon,
  SystemVehiclesIcon,
  SystemViewCardsIcon,
  SystemViewHistoryIcon,
  SystemViewListIcon,
  TemperatureIcon,
  TireIcon,
  TopNavFilterIcon,
  TopNavHelpIcon,
  TopNavNotificationIcon,
  TopNavSearchIcon,
  TrailerDoorStatusIcon,
  TripListIcon,
  UpArrowIcon,
  UrgentIcon,
  VehicleIcon,
  VicinitySearchIcon,
  VisionCameraOutlinedIcon,
  ZoomToFitIcon,
  SideNavCrashBoxxIcon : SideNavCrashboxxIcon
};

export type ThemeIconName = keyof typeof ICON_MAP;

export type ThemeIconProviderProps = {
  name: ThemeIconName;
  legacyIcon: React.ReactNode;
  folderColor?: string;
} & IconProps;

export function ThemeIconProvider({
  name,
  legacyIcon,
  ...iconProps
}: ThemeIconProviderProps) {
  const {isLegacy} = useThemeContext();

  if (isLegacy) {
    return <>{legacyIcon}</>;
  }

  const Icon = ICON_MAP[name];
  return Icon ? <Icon {...iconProps as any} /> : null;
}

export default React.memo(ThemeIconProvider);
